import { getEnvVariables } from "@Utils";

const getData = async () => {
  const { API_URL } = getEnvVariables();
  const document = localStorage.getItem("documento");
  const steps = ["uno", "dos", "tres", "cuatro", "cinco"];
  let dataReturn = {}
  for (const step of steps) {
    const resp = await fetch(
      `${API_URL}/personas/paso-${step}/consulta/${document}/`
    );
    const data = await resp.json();
    dataReturn = {...dataReturn, ...data}
  }
  localStorage.setItem("ready", true);
  localStorage.setItem("dataLastStep", JSON.stringify(dataReturn))
};

export default getData;
